// 判断是否为JSON格式
export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      return typeof obj === 'object' && obj !== null;
    } catch (e) {
      return false;
    }
  }
  return false;
}